import { lazy } from 'react';

export default [
    {
        path: '/new-taipei-band',
        exact: true,
        component: lazy(() => import(/* webpackChunkName: 'NewTaipeiBand' */ './layout')),
    },
];
